<div class="container-global">
  <h2 class="secondary-color">MON ESPACE</h2>
  <h3>Formations</h3>
  <div class="container-fil-ariane">
    <ags-fil-ariane [name]="'Mon espace'" [link]="'/account'"></ags-fil-ariane>
    <p class="space-fil-ariane">></p>
    <ags-fil-ariane [name]="'Mes formations'" [link]="'/mesformations'"></ags-fil-ariane>
    <p *ngIf="choosedFormation" class="space-fil-ariane">></p>
    <ags-fil-ariane
      *ngIf="choosedFormation"
      [name]="choosedFormation.reference"
      [link]="'/mesformations/' + choosedFormation.id"
    ></ags-fil-ariane>
  </div>
  <ags-formation-list (selectedFormation)="selectedFormation($event)" *ngIf="listOfSession"> </ags-formation-list>
  <ags-account-fiche-formation [idFormation]="idFormation" *ngIf="sessionPage">
  </ags-account-fiche-formation>

  <p *ngIf="notFoundPage">404 not found</p>
</div>
